if (!customElements.get('quantity-selector')) {
  customElements.define('quantity-selector', class extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const { signal } = this.abortController;
      this.input = this.querySelector('.quantity-selector__input');
      this.minus = this.querySelector('[name="minus"]');
      this.plus = this.querySelector('[name="plus"]');
      if (!this.input) return;

      this.addEventListener('click', event => {
        const button = event.target.closest('.quantity-selector__button');
        if (!button || button.disabled) return;
        button.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      }, { signal });

      this.input.addEventListener('change', () => this.update(), { signal });
      this.update();
    }

    update() {
      const value = Number(this.input.value);
      const min = this.input.min === '' ? null : Number(this.input.min);
      const max = this.input.max === '' ? null : Number(this.input.max);
      if (this.minus) this.minus.disabled = this.input.disabled || (min !== null && value <= min);
      if (this.plus) this.plus.disabled = this.input.disabled || (max !== null && value >= max);
    }

    disconnectedCallback() { this.abortController?.abort(); }
  });
}
